import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ReducerAction } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_SGU_DOMINIOS_API } from 'services/rotasp/path';
import {
	cadastrarMunicipioIbgeSuccess,
	cadastrarMunicipioIbgeFailure,
} from './actions';
import { Types, CadastrarMunicipioIbgeRequest } from './types';

function* cadastrarMunicipioIbgeRequest(request: ReducerAction) {
	const {
		token,
		payload,
	}: { token?: string; payload: CadastrarMunicipioIbgeRequest } = request;

	let body = { ...payload, idIbge: Number(payload.idIbge) };

	body = cleanEmpty(body) as CadastrarMunicipioIbgeRequest;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_SGU_DOMINIOS_API,
		`municipios-ibge`,
		body,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastrarMunicipioIbgeSuccess(response));
	} else {
		yield put(cadastrarMunicipioIbgeFailure());
	}
}

export default all([
	takeLatest(
		Types.CADASTRAR_MUNICIPIO_IBGE_REQUEST,
		cadastrarMunicipioIbgeRequest,
	),
]);
